import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Users, BookOpen, MapPin, LogOut, Search, TrendingUp, Building2 } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/admin/leads", label: "Lead / CRM", icon: Users },
  { to: "/admin/report", label: "Report SEO", icon: TrendingUp },
  { to: "/admin/guides", label: "Guide (CMS)", icon: BookOpen },
  { to: "/admin/dealers", label: "Rivenditori", icon: MapPin },
  { to: "/admin/locations", label: "Pagine Città", icon: Building2 },
  { to: "/admin/seo", label: "SEO", icon: Search },
];

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isActive = (n) => n.exact ? loc.pathname === n.to : loc.pathname.startsWith(n.to);

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="w-64 text-white flex flex-col fixed inset-y-0 hidden md:flex" style={{ backgroundColor: "#8F0C3B" }}>
        <div className="p-6"><Link to="/admin" className="text-2xl font-extrabold text-white" style={{ fontFamily: "Outfit" }}>SENIORCAR</Link><p className="text-white/60 text-xs mt-1">CMS & CRM</p></div>
        <nav className="flex-1 px-3 space-y-1">
          {NAV.map((n) => { const Ic = n.icon; return (
            <Link key={n.to} to={n.to} className={`flex items-center gap-3 px-4 py-3 rounded-lg font-semibold text-sm ${isActive(n) ? "bg-white/20 text-white" : "text-white/80 hover:bg-white/10"}`} data-testid={`admin-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "")}`}>
              <Ic size={18} /> {n.label}
            </Link>); })}
        </nav>
        <div className="p-4 border-t border-white/20">
          <p className="text-white/70 text-xs truncate mb-2">{user?.email} · {user?.role}</p>
          <Button onClick={logout} variant="ghost" className="w-full justify-start gap-2 text-white hover:bg-white/10 hover:text-white" data-testid="admin-logout"><LogOut size={18} /> Esci</Button>
        </div>
      </aside>
      <div className="flex-1 md:ml-64">
        <div className="md:hidden text-white p-4 flex items-center justify-between" style={{ backgroundColor: "#8F0C3B" }}>
          <span className="font-bold">SENIORCAR Admin</span>
          <Button onClick={logout} variant="ghost" size="sm" className="text-white"><LogOut size={16} /></Button>
        </div>
        <div className="md:hidden flex overflow-x-auto gap-1 px-2 pb-2" style={{ backgroundColor: "#8F0C3B" }}>
          {NAV.map((n) => <Link key={n.to} to={n.to} className={`px-3 py-2 rounded text-xs font-semibold whitespace-nowrap ${isActive(n) ? "bg-white/20 text-white" : "text-white/70"}`}>{n.label}</Link>)}
        </div>
        <main className="p-4 sm:p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
}
